exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".state-label-state-label-2cAduGLLmwr{color:var(--always-light-text);padding:4px 8px}.state-label-rounded-corners-7C7Q347Umwr{border-radius:4px}.state-label-state-none-1QicrVGjmwr{background-color:var(--alpha-10);color:var(--primary-text)}.state-label-state-queued-1itYvucbmwr{background-color:#008571}.state-label-state-inprogress-7FUBTnkxmwr{background-color:#2C7797}.state-label-state-canceled-1SXrF5sqmwr{background-color:#757575}.state-label-state-failed-ekx0airrmwr{background-color:var(--error-text);color:var(--primary-text-invert)}.state-label-state-succeeded-15Cnjypnmwr{background-color:var(--success-text);color:var(--primary-text-invert)}\n", ""]);
// Exports
exports.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"state-label": "state-label-state-label-2cAduGLLmwr",
	"stateLabel": "state-label-state-label-2cAduGLLmwr",
	"rounded-corners": "state-label-rounded-corners-7C7Q347Umwr",
	"roundedCorners": "state-label-rounded-corners-7C7Q347Umwr",
	"state-none": "state-label-state-none-1QicrVGjmwr",
	"stateNone": "state-label-state-none-1QicrVGjmwr",
	"state-queued": "state-label-state-queued-1itYvucbmwr",
	"stateQueued": "state-label-state-queued-1itYvucbmwr",
	"state-inprogress": "state-label-state-inprogress-7FUBTnkxmwr",
	"stateInprogress": "state-label-state-inprogress-7FUBTnkxmwr",
	"state-canceled": "state-label-state-canceled-1SXrF5sqmwr",
	"stateCanceled": "state-label-state-canceled-1SXrF5sqmwr",
	"state-failed": "state-label-state-failed-ekx0airrmwr",
	"stateFailed": "state-label-state-failed-ekx0airrmwr",
	"state-succeeded": "state-label-state-succeeded-15Cnjypnmwr",
	"stateSucceeded": "state-label-state-succeeded-15Cnjypnmwr"
};